import React from 'react';
import PropTypes from 'prop-types';
import createIcon from '@ux/icon/base.js';
import additionalIcons from './icons';
import NavigationItem from './NavigationItem';
import { useGetWindowHref } from '../lib/useGetWindowHref';
import { isNavItemActive } from '../lib/linkUtils';
import { getIconName } from '../lib/iconUtils';

const icons = {
  ...additionalIcons
};

/**
* Returns left sidebar links.
*
* @param {array} navigation Array of objects providing link data.
*
* @returns {React.ReactElement} Set of links for left sidebar.
*/

const SidebarNav = ({
  hovered,
  affixed,
  navigation = [],
  onClose,
  sidebarNavLinkHandler,
  primaryActiveNavLink
}) => {
  const browserUrlStr = useGetWindowHref();
  const activeBrowserUrl = primaryActiveNavLink ? primaryActiveNavLink : browserUrlStr;

  return navigation.map((navItem, index) => {
    if ((!navItem.href && !navItem.children && navItem.caption !== 'divider') || !navItem.caption) {
      return null;
    }

    const activeNavHandler = isNavItemActive(navItem, activeBrowserUrl);
    const isItemActive = navItem.active ?? activeNavHandler;
    let Icon;

    if (navItem.icon) {
      const iconStyle = getIconName({ ...navItem, active: isItemActive });

      if (!icons[iconStyle]) {
        icons[iconStyle] = createIcon(iconStyle, false);
      }

      Icon = icons[iconStyle];
    }

    if (navItem.caption === 'divider') {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <li aria-hidden='true' className='primary-nav-divider' key={ `divider-${index}` } />
      );
    }

    return (
      <NavigationItem
        key={ `navItem-${navItem.key}` }
        index={ index }
        navItem={{ ...navItem }}
        affixed={ affixed }
        hovered={ hovered }
        onClose={ onClose }
        icon={ Icon && <Icon alttext={ navItem.caption } /> }
        isActive={ isItemActive }
        sidebarNavLinkHandler={ sidebarNavLinkHandler }
        primaryActiveNavLink={ primaryActiveNavLink }
      />
    );
  });
};

SidebarNav.propTypes = {
  onClose: PropTypes.func,
  hovered: PropTypes.bool,
  affixed: PropTypes.bool,
  navigation: PropTypes.arrayOf(PropTypes.object),
  sidebarNavLinkHandler: PropTypes.func
};

export default SidebarNav;
